import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { aiKnowledgeDocs } from "./ai-knowledge-docs";

// ============================================================================
// ai_knowledge_chunks — Chunked content for vector search
// ============================================================================
export const aiKnowledgeChunks = sqliteTable("ai_knowledge_chunks", {
  id: text("id").primaryKey(), // ULID
  docId: text("doc_id")
    .notNull()
    .references(() => aiKnowledgeDocs.id),
  chunkIndex: integer("chunk_index").notNull(),
  content: text("content").notNull(),
  vectorId: text("vector_id"), // ID in Cloudflare Vectorize
  // Audit fields
  createdAt: text("created_at"),
});

export type AiKnowledgeChunk = typeof aiKnowledgeChunks.$inferSelect;
export type NewAiKnowledgeChunk = typeof aiKnowledgeChunks.$inferInsert;
